import { useMemo } from 'react';
import { useQueryParams } from '../useQueryParams';

export const useCurrentThreadId = () => {
  const { searchParams } = useQueryParams();
  const { editor } = searchParams;

  return useMemo(
    () => ({
      currentThreadId: editor,
    }),
    [editor],
  );
};
